import { z } from 'zod';

export const Equipment = z.object({
  id: z.number(),
  equipment_type: z.string(),
  name: z.string(),
  market: z.string(),
  supplier: z.string(),
  source: z.string(),
  capex_cost: z.string().nullable(),
  amortization_years: z.number().nullable(),
  annual_operating_cost_rate: z.string(),
  equipment_availability_hours_per_year: z.string().nullable(),
  amortization_per_hour: z.string().nullable(),
  run_cost_per_hour: z.string().nullable(),
  max_parts_per_process: z.number().nullable(),
  footprint_sq_ft: z.string().nullable(),
  power_consumption_kwh: z.string().nullable(),
  notes: z.string(),
  is_archived: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type Equipment = z.infer<typeof Equipment>;

export const EquipmentUpdate = Equipment.omit({
  id: true,
  equipment_availability_hours_per_year: true,
  amortization_per_hour: true,
  run_cost_per_hour: true,
  created_at: true,
  updated_at: true,
});

export type EquipmentUpdate = z.infer<typeof EquipmentUpdate>;
